import {IconPuzzle} from '@tabler/icons-react';
import type {ModuleEnum} from 'src/api/ProactApiClient';
import { PermissionOperationEnum} from 'src/api/ProactApiClient';
import {useGetActiveExtensionsQuery} from 'src/redux/queries/moduleExtension';
import {findModulePermission} from 'src/shared/auth/useHasModulePermission';
import {usePermissions} from 'src/shared/auth/usePermissions';
import type {
  ExtensionView,
  IUrlQueryTabConfig,
} from 'src/shared/hooks/useUrlQueryTabV2';
import {ExtensionFormTab} from 'src/app/module-extensions/ExtensionFormTab';

export const useExtensionTabs = (
  module: ModuleEnum,
  entityId: number
): IUrlQueryTabConfig<ExtensionView>[] => {
  const {data: activeExtensions} = useGetActiveExtensionsQuery();
  const {permissions} = usePermissions();

  if (!activeExtensions) return [];

  const extension = activeExtensions.extensions?.find(
    e => e.module === module
  );
  if (!extension) return [];

  return extension.formTabs
    .filter(tab => {
      if (!tab.permissionOperationName) return false;
      const permission = findModulePermission(
        permissions,
        module,
        PermissionOperationEnum.Custom,
        tab.permissionOperationName
      );
      return permission !== undefined;
    })
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map(tab => ({
      view: `ext-${tab.tabSlug}`,
      label: tab.tabLabel,
      tabsTabProps: {
        value: `ext-${tab.tabSlug}`,
        leftSection: <IconPuzzle size={14} />,
      },
      component: (
        <ExtensionFormTab
          formTabId={tab.id}
          formDefinitionId={tab.formDefinitionId}
          targetEntityId={entityId}
          module={module}
          formDefinitionExists={!!tab.formDefinitionName}
        />
      ),
    }));
};
